import StickyElement from './StickyElement';

const config = {
  name: 'StickyElement',
  class: StickyElement,
  options: {
    offsetElementSelector: '.siteHeader',
    padding: 20,
    classes: {
      beforeFirstBoundary: 'StickyElement--before-first-boundary',
      afterLastBoundary: 'StickyElement--after-last-boundary',
    },
  },
};

export default config;
